import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import PurchaseOrderDetail from "./PurchaseOrderDetail";
import PurchaseOrderReceipts from './PurchaseOrderReceipts';
import PurchaseOrderInvoices from './PurchaseOrderInvoices';
import PurchaseOrderFiles from './PurchaseOrderFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';

// Actions
import {
    getPurchaseOrder,
    changePurchaseOrderStatus,
    updatePurchaseOrder,
    uploadPurchaseOrderFiles,
    downloadPurchaseOrderFile,
    deletePurchaseOrderFile,
    deletePurchaseOrder,
    cleanPurchaseOrders
} from "../../../actions/purchase-orders";
import {addNotification} from "../../../actions/notifications";

class PurchaseOrderTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getPurchaseOrder(this.props.match.params.purchaseOrderId);
    }
    componentDidUpdate(prevProps) {
        const { purchaseOrder: prevPurchaseOrder } = prevProps;
        const { purchaseOrder } = this.props;

        if (purchaseOrder && purchaseOrder !== prevPurchaseOrder) this.setPurchaseOrder(purchaseOrder);
    }
    componentWillUnmount() {
        this.props.cleanPurchaseOrders();
    }

    // Tab handlers
    getSelectedIndex() {
        const {purchaseOrderId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/compras/pedidos/' + purchaseOrderId + '/detalle':
                return 0;
            case '/compras/pedidos/' + purchaseOrderId + '/albaranes':
                return 1;
            case '/compras/pedidos/' + purchaseOrderId + '/facturas':
                return 2;
            case '/compras/pedidos/' + purchaseOrderId + '/ficheros':
                return 3;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {purchaseOrderId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/compras/pedidos/' + purchaseOrderId + '/detalle';
                break;
            case 1:
                route = '/compras/pedidos/' + purchaseOrderId + '/albaranes';
                break;
            case 2:
                route = '/compras/pedidos/' + purchaseOrderId + '/facturas';
                break;
            case 3:
                route = '/compras/pedidos/' + purchaseOrderId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // PurchaseOrderDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updatePurchaseOrdersState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updatePurchaseOrder();
        this.setState({
            editMode: false
        });
    };
    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validatePurchaseOrder);
    };
    setPurchaseOrder = (purchaseOrder) => {
        this.setState({
            order_code: purchaseOrder.get('order_code'),
            // object fields
            status: purchaseOrder.get('status')
        }, () => this.validatePurchaseOrder);
    };
    validatePurchaseOrder = () => {
        if (
            this.state.order_code !== ''
        ) {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        const canNewReceipt = ['partial', 'received'].includes(this.props.purchaseOrder.get('status'));
        const canNewInvoice = ['received'].includes(this.props.purchaseOrder.get('status'));

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar pedido de compra',
                        body: (
                            <DeleteDialog
                                text={ this.props.purchaseOrder.get('order_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deletePurchaseOrder(this.props.purchaseOrder.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/compras/pedidos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/compras/pedidos">Pedidos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.purchaseOrder.get('order_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        { canNewReceipt
                                            ? <button
                                                className="btn btn-primary"
                                                onClick={ () => {
                                                    this.props.history.push('/compras/albaranes/nuevo', {
                                                        purchaseOrder: this.props.purchaseOrder
                                                    });
                                                }}
                                            >
                                                <Icon icon="insert"/>Albaran
                                            </button>
                                            : null
                                        }
                                        { canNewInvoice
                                            ? <button
                                                className="btn btn-primary"
                                                onClick={ () => {
                                                    this.props.history.push('/compras/facturas/nuevo', {
                                                        purchaseOrder: this.props.purchaseOrder
                                                    });
                                                }}
                                            >
                                                <Icon icon="insert"/>Factura
                                            </button>
                                            : null
                                        }
                                        { this.props.purchaseOrder.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.purchaseOrder.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Albaranes</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Facturas</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 3})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <PurchaseOrderDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                purchaseOrder={this.props.purchaseOrder}
                                                updatePurchaseOrder={this.props.updatePurchaseOrder}
                                                changePurchaseOrderStatus={this.props.changePurchaseOrderStatus}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <PurchaseOrderReceipts
                                                purchaseOrder={this.props.purchaseOrder}
                                                canNewReceipt={canNewReceipt}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <PurchaseOrderInvoices
                                                purchaseOrder={this.props.purchaseOrder}
                                                canNewInvoice={canNewInvoice}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <PurchaseOrderFiles
                                                purchaseOrder={this.props.purchaseOrder}
                                                uploadPurchaseOrderFiles={this.props.uploadPurchaseOrderFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadPurchaseOrderFile={this.props.downloadPurchaseOrderFile}
                                                deletePurchaseOrderFile={this.props.deletePurchaseOrderFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const purchaseOrderReducer = state.purchaseOrders;

    // PurchaseOrder
    let purchaseOrder = purchaseOrderReducer.get('payload') || Map({});

    if (!(purchaseOrder instanceof Map)) {
        purchaseOrder = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: purchaseOrderReducer.get('isUploading') || false,
        percent: purchaseOrderReducer.get('percent') || 0
    });

    return {
        purchaseOrder,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPurchaseOrder: (purchaseOrderId) => dispatch(getPurchaseOrder(purchaseOrderId)),
        updatePurchaseOrder: (purchaseOrderId, purchaseOrder) => dispatch(updatePurchaseOrder(purchaseOrderId, purchaseOrder)),
        changePurchaseOrderStatus: (purchaseOrderId, status) => dispatch(changePurchaseOrderStatus(purchaseOrderId, status)),
        uploadPurchaseOrderFiles: (purchaseOrderId, files) => dispatch(uploadPurchaseOrderFiles(purchaseOrderId, files)),
        downloadPurchaseOrderFile: (purchaseOrderId, fileId) => dispatch(downloadPurchaseOrderFile(purchaseOrderId, fileId)),
        deletePurchaseOrderFile: (purchaseOrderId, fileId) => dispatch(deletePurchaseOrderFile(purchaseOrderId, fileId)),
        deletePurchaseOrder: (purchaseOrderId) => dispatch(deletePurchaseOrder(purchaseOrderId)),
        cleanPurchaseOrders: () => dispatch(cleanPurchaseOrders()),
        addNotification: (notification) => dispatch(addNotification(notification))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderTabs);



// WEBPACK FOOTER //
// ./src/containers/purchases/orders/PurchaseOrderTabs.js